import { useEmailContent, LoadboardLabel, LoadboardValue } from "@/components/dataPages/loadboard";
import { Mail, PhoneCall } from "lucide-react";
import { useSelector } from "react-redux";

export const LoadboardBrokerInfo = ({ load }) => {
    const user = useSelector((state) => state.user.data);
    const metaDataKeys = Object.keys(load.displayMetadata);
    const emailAddress = load.brokerInfo?.contactEmail;
    const mailtoLink = useEmailContent({ emailAddress, load, user });

    return (
        <div className="h-[161px] w-full bg-cm-p-surface rounded-lg gap-1 flex flex-col p-4">
            <LoadboardLabel text="Broker info" />
            <div className="w-full mt-1 mb-4 flex flex-row gap-4 items-center">
                {load.brokerInfo?.name ? <LoadboardValue>{load.brokerInfo?.name}</LoadboardValue> : null}
                {load.brokerInfo?.contactPhone ? (
                    <>
                        <a
                            className="font-medium text-xs/[19px] text-cm-accent inline-flex gap-2 items-center"
                            href={`tel:${load.brokerInfo.contactPhone}`}
                        >
                            <PhoneCall className="w-4" />
                            Call
                        </a>
                        {load.brokerInfo.contactEmail ? <div className="h-4 w-[1.5px] bg-cm-p-outline rounded" /> : null}
                    </>
                ) : null}
                {emailAddress && mailtoLink ? (
                    <a className="font-medium text-xs/[19px] text-cm-accent inline-flex gap-2 items-center" href={mailtoLink}>
                        <Mail className="w-4" />
                        Email
                    </a>
                ) : null}
            </div>
            <div className="flex flex-col gap-1 justify-center">
                <LoadboardLabel text="Note from broker" />
                <div className="text-cm-text-primary text-xs/[19px] italic">
                    {metaDataKeys.length
                        ? metaDataKeys.map((key, index) => (
                              <div key={index}>
                                  {key}: {load.displayMetadata[key] || "- "}
                              </div>
                          ))
                        : "-"}
                </div>
            </div>
        </div>
    );
};
